import brFlag from "../assets/images/flags/brasil.jpg"
import usFlag from "../assets/images/flags/us.jpg"

const languages = {
  en: {
    label: "English",
    flag: usFlag,
  },
  pt: {
    label: "Português",
    flag: brFlag,
  },
}

export default languages
